let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

export default ({ app, $axios, store, redirect, route }) => {
  const handleSessionExpired = () => {
    store.commit('user/clearSession');
    store.dispatch('ui/showError', {
      title: 'Ops! Sessão Expirada',
      text: 'Para retomar de onde parou, faça login novamente.',
      callback: () => {
        const query = route.path === '/login' ? {} : { goto: route.path };
        redirect({ path: '/login', query: query });
      }
    });
  };

  $axios.onRequest((config) => {
    if (store.state.env === 'local') {
      config.method = 'get';
    }
    const isRefreshRoute =
      config.skipAuth ||
      (config.url && config.url.includes('sessions/refresh'));

    if (isRefreshRoute) {
      if (config.headers && typeof config.headers.delete === 'function') {
        config.headers.delete('utoken'); // Axios v1.0+
      } else {
        if (config.headers) delete config.headers['utoken']; // Axios antigo
        if (config.headers?.common) delete config.headers.common['utoken'];
      }
      return config;
    }

    const token = store.state.user?.session?.token;
    if (token) {
      if (config.headers && typeof config.headers.set === 'function') {
        config.headers.set('utoken', token);
      } else {
        config.headers['utoken'] = token;
      }
    }

    return config;
  });

  $axios.onError(async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status || error.request?.status;
    const errorCode = error.response?.data?.errorCode;

    if (status === 401 && errorCode === 2 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            if (
              originalRequest.headers &&
              typeof originalRequest.headers.set === 'function'
            ) {
              originalRequest.headers.set('utoken', token);
            } else {
              originalRequest.headers['utoken'] = token;
            }
            return $axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = store.state.user.session.refreshToken;

        const response = await app.$api.auth.refresh(refreshToken);

        const newToken = response.data.token;
        const newRefreshToken = response.data.refreshToken;
        const deviceManagementId =
          response.data.deviceManagementId ||
          store.state.user.session.deviceManagementId;

        store.commit('user/setSession', {
          token: newToken,
          refreshToken: newRefreshToken,
          deviceManagementId
        });

        if (
          originalRequest.headers &&
          typeof originalRequest.headers.set === 'function'
        ) {
          originalRequest.headers.set('utoken', newToken);
        } else {
          originalRequest.headers['utoken'] = newToken;
        }

        processQueue(null, newToken);

        return $axios(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        handleSessionExpired();

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    const isAuthenticationError =
      errorCode === 1 || (status === 401 && errorCode !== 2);

    if (isAuthenticationError) {
      handleSessionExpired();
    }

    return Promise.reject(error);
  });
};
